import {readVideoSourceUpload,type VideoSourceUpload} from '../../protocol/video-source-upload';
type Upload=(input:VideoSourceUpload)=>Promise<string>;
type Prepare=()=>Promise<void>;
let transport:Upload|null=null;
let stage:Prepare|null=null;
export function connectVideoSourceUpload(next:Upload){transport=next;return()=>{if(transport===next)transport=null;};}
export function connectVideoSourceUploadStage(next:Prepare){stage=next;return()=>{if(stage===next)stage=null;};}
export async function stageVideoSourceUpload(file:File){
  const current=stage,destination=transport;
  if(!current||!destination)throw new Error('현재 와카 작업을 불러온 뒤 다시 시도해 주세요.');
  const input=readVideoSourceUpload({filename:file.name,blob:file});
  await current();
  // Revalidate before the storage side effect, not just when its result arrives.
  if(stage!==current||transport!==destination)throw new Error('작업 연결이 바뀌어 업로드를 시작하지 않았습니다.');
  const id=await destination(input);
  if(stage!==current||transport!==destination)throw new Error('작업 연결이 바뀌어 원본 선택을 멈췄습니다.');
  return id;
}
/** Narrow port RPC: one image to the already-bound work, never caller-supplied URLs or scope. */
export function createVideoSourceUploadRpc(send:(message:unknown)=>void,begin:()=>()=>void,timeoutMs=180000){
  let sequence=0,disposed=false;
  const pending=new Map<string,{resolve:(id:string)=>void;reject:(error:Error)=>void;finish:()=>void;timer:ReturnType<typeof setTimeout>}>();
  return {
    upload(input:VideoSourceUpload):Promise<string>{
      if(disposed)return Promise.reject(new Error('작업 연결이 종료됐습니다.'));
      if(pending.size)return Promise.reject(new Error('앞선 이미지 업로드를 기다려 주세요.'));
      const validated=readVideoSourceUpload(input);
      return new Promise((resolve,reject)=>{
        const id=`image-upload-${++sequence}`,finish=begin();
        const timer=setTimeout(()=>{pending.delete(id);finish();reject(new Error('업로드 반영 여부를 확인하지 못했습니다. 재업로드 전 현재 원본 자료함을 확인해 주세요.'));},timeoutMs);
        pending.set(id,{resolve,reject,finish,timer});
        try{send({type:'video-source-upload',id,input:validated});}
        catch{clearTimeout(timer);pending.delete(id);finish();reject(new Error('이미지를 전달하지 못했습니다.'));}
      });
    },
    receive(value:unknown){
      if(!value||typeof value!=='object'||!('type' in value)||value.type!=='video-source-uploaded'||!('id' in value)||typeof value.id!=='string')return false;
      const request=pending.get(value.id);if(!request)return true;
      pending.delete(value.id);clearTimeout(request.timer);request.finish();
      if('ok' in value&&value.ok===true&&'assetId' in value&&typeof value.assetId==='string'&&value.assetId.length>0&&value.assetId.length<=128)request.resolve(value.assetId);
      else request.reject(new Error('message' in value&&typeof value.message==='string'?value.message:'이미지 반영을 확인하지 못했습니다. 원본 자료함을 확인해 주세요.'));
      return true;
    },
    dispose(){disposed=true;for(const request of pending.values()){clearTimeout(request.timer);request.finish();request.reject(new Error('작업 연결이 종료됐습니다.'));}pending.clear();},
  };
}
